// extracted by mini-css-extract-plugin
export var calendar = "calendar-module--calendar--Bok2y";
export var calendar__currentMonth = "calendar-module--calendar__currentMonth--GXaDJ";
export var calendar__datepicker = "calendar-module--calendar__datepicker--I484X";
export var calendar__datepickerDay = "calendar-module--calendar__datepickerDay--RWaMf";
export var calendar__datepickerDayOutsideMonth = "calendar-module--calendar__datepickerDayOutsideMonth--d7E10";
export var calendar__footer = "calendar-module--calendar__footer---2Rmb";
export var calendar__header = "calendar-module--calendar__header--kw3yF";
export var calendar__legend = "calendar-module--calendar__legend--Q323y";
export var calendar__legendAwayIcon = "calendar-module--calendar__legendAwayIcon--tGDI7";
export var calendar__legendHomeIcon = "calendar-module--calendar__legendHomeIcon--sxFaj";
export var calendar__legendIcon = "calendar-module--calendar__legendIcon--vtQnT";
export var calendar__modal = "calendar-module--calendar__modal--C004I";
export var calendar__monthIcon = "calendar-module--calendar__monthIcon--OW1Up";
export var calendar__monthIconNext = "calendar-module--calendar__monthIconNext--6plNU";
export var calendar__monthIconPrev = "calendar-module--calendar__monthIconPrev--Cz9sg";
export var icoChevron = "calendar-module--ico-chevron--YdhfQ";